module.exports = __webpack_public_path__ + "img/undraw_Resume_folder_re_e0bi.645f3f62.svg";